import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import toast from "react-hot-toast";
import { authActions } from "../../redux/store";
import eraseCookie from "../../helper/eraseCookie";
import getCookie from "../../helper/getCookie";
import getDecryptData from "../../helper/getDecryptData";
import axiosInstance from "../../axiosInstance";

const AccountSidebar = () => {

  const isLoginFromLocalStorage = getCookie('token') ? true : false;

  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);
  const decryptdatajson = getDecryptData();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //logout
  const handleLogout = () => {
    try {
      dispatch(authActions.logout());
      toast.success("Logout Successfully");
      navigate("/login");
      // localStorage.clear();
      eraseCookie('token')

    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteAccount = async () => {
    if (!decryptdatajson?._id) {
      toast.error("User not found");
      return;
    }

    const confirmed = window.confirm("Are you sure you want to delete your account?");
    if (!confirmed) return;

    try {
      const response = await axiosInstance.put(`/admin/soft-delete-user/${decryptdatajson._id}`);
      dispatch(authActions.logout());
      eraseCookie('token');
      setIsLogin(false);
      toast.success(response.data?.message || "Account deleted successfully");
      navigate("/login");
    } catch (error) {
      console.error("Error deleting account:", error);
      toast.error(error.response?.data?.message || "Error deleting account");
    }
  };

  const isActive = (path) => {
    return window.location.pathname === path ? 'active' : '';
  };

  return (
    <>


      <div className="col-lg-3 my-lg-0 my-md-1 ">
        <div id="sidebar" className="bg-white border">
          <div className="h4 text-dark">Account</div>
          <ul>


            {isLogin &&
              <li className={isActive('/account')} >
                <Link
                  to="/account"
                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-box pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">My Account</div>
                    <div className="link-desc">
                      View &amp; Manage orders and returns
                    </div>
                  </div>
                </Link>
              </li>
            }

            {isLogin &&
              <li className={isActive('/account/all-order')} >
                <Link
                  to="/account/all-order"

                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-box-open pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">My Order</div>
                    <div className="link-desc">
                      Manage all my Order 
                    </div>
                  </div>
                </Link>
              </li>
            }

            {/* {isLogin &&
              <li className={isActive('/account/all-enquire')} >
                <Link
                  to="/account/all-enquire"

                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-box-open pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">Claim Enquiries</div>
                    <div className="link-desc">
                      My Claim Enquiries
                    </div>
                  </div>
                </Link>
              </li>
            } */}

            {/* {isLogin &&
              <li className={isActive('/account/all-transactions')} >
                <Link
                  to="/account/all-transactions"

                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-box-open pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">All Payments</div>
                    <div className="link-desc">
                      My all payments
                    </div>
                  </div>
                </Link>
              </li>
            } */}

            {isLogin &&
              <>
                <li className={isActive('/account/profile')} >
                  <Link
                    to="/account/profile"
                    className="text-decoration-none d-flex align-items-start"
                  >
                    <div className="far fa-address-book pt-2 me-3" />
                    <div className="d-flex flex-column">
                      <div className="link">My Profile</div>
                      <div className="link-desc">  Change your profile details</div>
                    </div>
                  </Link>
                </li>

                {/* <li className={isActive('/account/profile-kyc')} >
                  <Link
                    to="/account/profile-kyc"
                    className="text-decoration-none d-flex align-items-start"
                  >
                    <div className="far fa-address-book pt-2 me-3" />
                    <div className="d-flex flex-column">
                      <div className="link"> Health Profile</div>
                      <div className="link-desc">  Change your  personal health profile</div>
                    </div>
                  </Link>
                </li> */}



              </>

            }

            {/* <li className={isActive('/wishList')} >
              <Link
                to="/wishList"
                className="text-decoration-none d-flex align-items-start"
              >
                <div className="far fa-address-book pt-2 me-3" />
                <div className="d-flex flex-column">
                  <div className="link">My wishlist</div>
                  <div className="link-desc">  Choose your wishList</div>
                </div>
              </Link>
            </li> */}


            {/* <li className={isActive('/comparsion')} >
              <Link
                to="/comparsion"
                className="text-decoration-none d-flex align-items-start"
              >
                <div className="far fa-address-book pt-2 me-3" />
                <div className="d-flex flex-column">
                  <div className="link">My comparsion</div>
                  <div className="link-desc">  Compare your products details</div>
                </div>
              </Link>
            </li> */}

            {isLogin &&
              <li className={isActive('/account/password')} >
                <Link
                  to="/account/password"
                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="far fa-user pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">Change Password</div>
                    <div className="link-desc">
                      Change your profile password
                    </div>
                  </div>
                </Link>
              </li>
            }

            {isLogin &&
              <li className={isActive('/account/support')} >
                <Link
                  to="/account/support"
                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-headset pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">Help &amp; Support</div>
                    <div className="link-desc">
                      Contact Us for help and support
                    </div>
                  </div>
                </Link>
              </li>
            }

            {isLogin &&
              <li>
                <button
                  type="button"
                  onClick={handleDeleteAccount}
                  className="text-decoration-none d-flex align-items-start border-0 bg-transparent w-100 text-start"
                >
                  <div className="far fa-trash-alt pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">Delete Account</div>
                    <div className="link-desc">
                      Delete or disable your account
                    </div>
                  </div>
                </button>
              </li>
            }

            {isLogin &&
              <li   >
                <Link
                  onClick={handleLogout}
                  className="text-decoration-none d-flex align-items-start"
                >
                  <div className="fas fa-headset pt-2 me-3" />
                  <div className="d-flex flex-column">
                    <div className="link">Logout </div>
                    <div className="link-desc">
                      Logout your account
                    </div>
                  </div>
                </Link>
              </li>
            }



          </ul>
        </div>
      </div>



    </>
  )
}

export default AccountSidebar
